<template>
  <div class="inner-navbar">
    <div v-if="tablet">
      <button
        class="inner-navbar__button"
        :aria-label="$t('general.cta.toggleNavigation')"
        @click="$emit('setMenuOpen')"
      >
        <icon
          class="inner-navbar__button__icon"
          :data="pageIcons[content.iconOpen]"
          height="1.125rem"
          width="1.125rem"
        ></icon>
      </button>
      <SocialShare class="inner-navbar__social" />
    </div>
    <button
      class="inner-navbar__button"
      @click="$emit('setMenuOpen')"
      v-if="desktop || mobile"
    >
      <icon
        class="inner-navbar__button__icon"
        :data="pageIcons[content.iconOpen]"
        height="1.125rem"
        width="1.125rem"
      ></icon>
    </button>
    <a
      :href="content.linkLogo"
      :aria-label="$t('general.cta.toEni')"
      target="_blank"
    >
      <icon
        class="inner-navbar__logo"
        :data="pageIcons[content.logo]"
        width="6.375rem"
        height="1.875rem"
        original
      ></icon>
    </a>

    <SocialShare v-if="mobile" class="inner-navbar__social" />
    <!-- <button class="inner-navbar__social" v-if="mobile">
      <icon
        :data="pageIcons[content.socialSharing.icon]"
        width="1.625rem"
        height="1.625rem"
        class="inner-navbar__social__icon"
      ></icon>
    </button> -->
    <LanguageSwitcher
      :content="content.languageSwitcher"
      v-if="tablet"
      class="inner-navbar__languages"
    />
  </div>
</template>

<script setup>
import { pageIcons } from "../../plugins/page-icons";
import { computed } from "@vue/reactivity";
import { inject } from "vue";

import LanguageSwitcher from "./LanguageSwitcher.vue";
import SocialShare from "./SocialShare.vue";

defineProps({
  content: Object,
  mobile: Boolean,
  tablet: Boolean,
  desktop: Boolean,
});

const tvaMq = inject("$tvaMq");
// const mobile = computed(() => tvaMq.value === "mobile");
const tablet = computed(() => tvaMq.value === "tablet");
const desktop = computed(() => tvaMq.value === "desktop");
</script>

<style lang="scss" scoped>
.inner-navbar {
  width: fit-content;
  border-radius: 30px;
  padding-right: toRem(31.5);
  background-color: $scala-grigi-white;
  @include ombra-ampia;

  &__button {
    width: toRem(50);
    height: toRem(50);
    border-radius: 100%;
    background-color: $scala-grigi-white;
    @include ombra-ampia;

    &__icon {
      transition: color 0.3s linear;
      color: $scala-grigi-gray_2;
    }

    &:hover > .navbar__left__button__icon {
      color: $scala-grigi-gray_1;
    }
  }

  &__social {
    :deep(.social-share__content-wrapper) {
      .desktop &,
      .tablet &,
      .large & {
        right: initial;
        left: 50%;
        transform: translateX(-50%);
      }

      .mobile & {
        right: -1rem;
      }
    }
  }

  &__languages {
    margin-left: auto;
    margin-right: toRem(25);
  }

  &__logo {
    margin-left: toRem(16);
  }
}

.tablet,
.mobile {
  .inner-navbar {
    width: 90%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0px 0px toRem(30) toRem(30);

    &__languages {
      margin: 0;
    }

    &__social {
      margin-left: toRem(23);
    }
  }
}

.mobile {
  .inner-navbar {
    width: 80%;
  }
}
</style>
